import ModifierChildProductCombo from "./ModifierChildProductCombo.js";

export default function ModifierCategoryChildProductCombo(props) {
    const modifiers = props.modifierCategoryDetails.mods?.map((item, index) => {
        let currentObj = ""; // Filtering and passing just the modifier Form Data
        let isChecked = "";
        let fieldName = "";
        if (props.modifierCategoryDetails.type === "Radio") {
            fieldName = `RadioModCatId${props.modifierCategoryDetails.modCategoryId}`;
            currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
            isChecked = currentObj[fieldName];
        } else if (props.modifierCategoryDetails.type === "Check") {
            fieldName = `CheckModCatId${props.modifierCategoryDetails.modCategoryId}ModId${item.modId}`;
            currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
            isChecked = currentObj[fieldName];
        } else if (props.modifierCategoryDetails.type === "Substitution") {
            fieldName = `SubRadioModCatId${props.modifierCategoryDetails.modCategoryId}`;
            currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
            isChecked = currentObj[fieldName];
        }
        return (
            <ModifierChildProductCombo 
                key={item.modId}
                modifierDetails={item}
                type={props.modifierCategoryDetails.type}
                modCatId={props.modifierCategoryDetails.modCategoryId}
                handleProductComboModFormChange={props.handleProductComboModFormChange}
                productFormDataMods={props.productFormDataMods}
                isChecked={isChecked} // determined by productFormDataMods (mapped modifiers from productFormData)
                addToProductComboError={props.addToProductComboError}
                currentLocation={props.currentLocation}
                priceInc={props.priceInc}

            />
        )
    })

    // Error Status & Styling
    const validationObj = props.productFormDataModCatValidation.find((modCat) => {
        return modCat.ModCatId === props.modifierCategoryDetails.modCategoryId;
    });
    
    let badgeClassStyles = "";
    if (validationObj.HasError) {
        badgeClassStyles = "text-bg-danger";
    } else {
        badgeClassStyles = "text-bg-light badgeLight";
    }
    // Choose Amount
    let chooseAmountText = "";
    if (props.modifierCategoryDetails.minValue == 0) {
        chooseAmountText = `Choose up to ${props.modifierCategoryDetails.maxValue}`
    } else if (props.modifierCategoryDetails.minValue == props.modifierCategoryDetails.maxValue) {
        chooseAmountText = `Choose ${props.modifierCategoryDetails.maxValue}`
    } else {
        chooseAmountText = `Choose between ${props.modifierCategoryDetails.minValue} - ${props.modifierCategoryDetails.maxValue}`
    }

    return (
        <>
            <div className="col-12">
                <hr className="text-body-tertiary"/>
            </div>
            <div className="col-12 d-flex justify-content-between pb-1">
                <b>{props.modifierCategoryDetails.modCategoryName}</b>
                {props.modifierCategoryDetails.maxValue && <span className={`badge ${badgeClassStyles}`}>{chooseAmountText}</span>}
            </div>
            {modifiers}
        </>
    )
}